/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import type { ChangeEventHandler } from "react";
import React, { useState, useContext, useRef, useEffect, useMemo } from "react";
import { FaFileExcel } from "react-icons/fa";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-expect-error
import { ExcelRenderer } from "react-excel-renderer";
import {
  Grid,
  GridColumn as Column,
  getSelectedState,
} from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { getter } from "@progress/kendo-react-common";
import {
  Button,
  Card,
  CardContent,
  Input,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbSeparator,
  BreadcrumbPage,
  DatePicker,
  Combobox,
  DialogTrigger,
} from "@repo/ui";
import {
  useDeleteRoute,
  useGenerateRoster,
  useGetAllRoutes,
  useUpdateRoutesTeam,
  useGenerateBulkRoaster,
  useGetRosterTemplate,
  useGetRouteEditTemplate,
  useEditRoutesInBulk,
  useSwapRouteTeam,
  useExportRoutes,
} from "utils/apis/rotes.api";
import { isOperationAllowed, showToast } from "utils/helper";
import { UserContext } from "utils/reducers/user";
import Layout from "components/layout";
import { Link } from "react-router-dom";
import { formatDate } from "date-fns";
import { Permissions } from "utils/enums";
import { PREV_DAY_DATE } from "utils/constant";
import { DownloadIcon, UploadIcon, Users } from "lucide-react";
import {
  useGetCashCenters,
  useGetRegions,
  useGetRouteByCashCenter,
} from "utils/apis/lookups.api";
import moment from "moment";
import { MdSwapHoriz } from "react-icons/md";
import EditRoute from "./edit-route";
import { ExcelExport } from "@progress/kendo-react-excel-export";

const exportRoutesKeys = [
  "routeNo",
  "region",
  "routeArea",
  "routeType",
  "cashCenter",
  "description",
  "busTime",
  "routeTime",
  "vanRegistrationNo",
  "cashBoxSerial",
  "hhtSerial",
  "printerSerial",
  "driverId",
  "driverName",
  "teamLeaderId",
  "ctlName",
  "guard1Id",
  "guard1Name",
  "guard2Id",
  "guard2Name",
  "guard3Id",
  "guard3Name",
  "status",
  "requestedBy",
  "comments",
];

const exportRostersKeys = [
  "routeNo",
  "region",
  "routeArea",
  "routeType",
  "cashCenter",
  "description",
  "busTime",
  "routeTime",
  "vanRegistrationNo",
  "cashBoxSerial",
  "hhtSerial",
  "printerSerial",
  "driverId",
  "driverName",
  "driverDesignation",
  "driverRegulatoryID",
  "driverContact",
  "teamLeaderId",
  "ctlName",
  "ctlDesignation",
  "ctlRegulatoryID",
  "guard1Nationality",
  "ctlContact",
  "guard1Id",
  "guard1Name",
  "guard1Designation",
  "guard1RegulatoryID",
  "teamLeaderNationality",
  "guard1Contact",
  "guard2Id",
  "guard2Name",
  "guard2Designation",
  "guard2RegulatoryID",
  "guard2Contact",
  "guard3Id",
  "guard3Name",
  "guard3Designation",
  "guard3RegulatoryID",
  "guard3Contact",
  "status",
  "requestedBy",
  "remarks",
];
const exportRoutesListKeys = [
  "routeNo",
  "region",
  "routeArea",
  "routeType",
  "cashCenter",
  "description",
  "busTime",
  "routeTime",
  "vanRegistrationNo",
  "cashBoxSerial",
  "hhtSerial",
  "printerSerial",
  "driverId",
  "driverName",
  "driverDesignation",
  "driverRegulatoryID",
  "driverContact",
  "driverNationality",
  "teamLeaderId",
  "teamLeaderName",
  "teamLeaderDesignation",
  "teamLeaderRegulatoryID",
  "teamLeaderContact",
  "teamLeaderNationality",
  "guard1Id",
  "guard1Name",
  "guard1Designation",
  "guard1RegulatoryID",
  "guard1Contact",
  "guard1Nationality",
  "guard2Id",
  "guard2Name",
  "guard2Designation",
  "guard2RegulatoryID",
  "guard2Contact",
  "guard2Nationality",
  "guard3Id",
  "guard3Name",
  "guard3Designation",
  "guard3RegulatoryID",
  "guard3Contact",
  "guard3Nationality",
  "status",
  "requestedBy",
  "remarks",
];
export default function RoutesManagement() {
  const initialDataState = {
    sort: [
      {
        field: "code",
        dir: "asc",
      },
    ],
  };

  const currentDate = new Date();

  const DATA_ITEM_KEY = "routeId";
  const SELECTED_FIELD = "selected";
  const idGetter = getter(DATA_ITEM_KEY);

  const { CashCenterId, Roles } = useContext(UserContext);

  const [selectedState, setSelectedState] = useState<any>({});
  const [dataState, setDataState] = useState<any>(initialDataState);
  const [selectedRoutes, setSelectedRoutes] = useState([]);
  const [selectedCashCenter, setSelectedCashCenter] = useState(CashCenterId);
  const [selectedRegion, setSelectedRegion] = useState("");

  const [operationDate, setOperationDate] = useState(currentDate);
  const [btnRosterDisabled, setBtnRosterDisabled] = useState(true);

  const [btnDeleteRouteDisabled, setBtnDeleteRouteDisabled] = useState(true);
  const [btnDeleteRouteTxt, setBtnDeleteRouteTxt] = useState("Remove Routes");

  const [refresh, setRefresh] = useState(false);
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const [openBulkUpload, setOpenBulkUpload] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [uploadRoutes, setUploadRoutes] = useState<any[]>([]);
  const [openRoutesFileUpload, setOpenRoutesFileUpload] = useState(false);

  const [swapRouteA, setSwapRouteA] = useState<string>("");
  const [swapRouteB, setSwapRouteB] = useState<string>("");
  const [swappedTeam, setSwappedTeam] = useState<any[]>([]);

  const [exportRoutesList, setExportRoutesList] = useState<any>(null);
  const [routesTeams, setRoutesTeams] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");
  const pageSize = 25;
  const [bulkServiceDateTime, setBulkServiceDateTime] =
    useState<Date>(currentDate);

  const onBulkServiceDateChanged = (date?: Date) => {
    if (date) setBulkServiceDateTime(date);
    else setBulkServiceDateTime(currentDate);
  };

  const routesTeamsList = useRef<any[]>([]);
  const _routesTemplateExport = React.createRef<ExcelExport | null>();
  const _rosterTemplateExport = React.createRef<ExcelExport | null>();
  const _routesExport = React.createRef<ExcelExport | null>();

  const {
    data: routes,
    refetch: refetchRoutes,
    isFetching: loadingRequests,
  } = useGetAllRoutes({
    pageNumber: currentPage,
    pageRowCount: pageSize,
    cashCenterId: selectedCashCenter,
    region: selectedRegion,
    searchCriteria: filter.length >= 3 ? filter : "",
  });
  const {
    mutate: exportRoutes,
    data: exportRoutesRes,
    isPending: gettingRoutesExport,
    reset: resetRoutesExport,
  } = useExportRoutes();

  const { data: routesToSwap, refetch: refetchSwapRoutes } =
    useGetRouteByCashCenter(selectedCashCenter);

  const { data: cashCenters } = useGetCashCenters();
  const { data: regions } = useGetRegions("UAE");

  const {
    mutate: generateBulkRoaster,
    isPending: generateBulkRoasterPending,
    isSuccess: generateBulkRoasterSuccess,
    isError: generateBulkRoasterError,
  } = useGenerateBulkRoaster();

  const {
    mutate: updateRoutesTeam,
    isSuccess: updateRouteTeamSuccess,
    isError: updateRouteTeamError,
    data: updateRouteTeamRes,
    isPending: updateRouteTeamPending,
  } = useUpdateRoutesTeam();

  const {
    mutate: generateRoster,
    isSuccess: generateRosterSuccess,
    isError: generateRosterError,
  } = useGenerateRoster();

  const {
    mutate: deleteRoute,
    isSuccess: deleteRouteSuccess,
    isError: deleteRouteError,
  } = useDeleteRoute();

  const {
    mutate: getRosterTemplate,
    data: getRosterTemplateRes,
    reset: resetRosterTemplateData,
  } = useGetRosterTemplate();

  const {
    mutate: getRouteTemplate,
    data: routeTemplateRes,
    reset: resetRouteTemplateData,
  } = useGetRouteEditTemplate();

  const { mutate: editRoutesBulk, isPending: editRoutesBulkPending } =
    useEditRoutesInBulk();

  const {
    mutate: swapRouteTeam,
    isPending: swappingRouteTeam,
    isSuccess: isSwapSuccessful,
  } = useSwapRouteTeam();

  useEffect(() => {
    if (routeTemplateRes) {
      excelExport();
      resetRouteTemplateData();
    }
    if (exportRoutesList) {
      routesExcelExport();
      setExportRoutesList(null);
    }
    if (isSwapSuccessful) {
      refetchRoutes();
      refetchSwapRoutes();
      setSwapRouteA("");
      setSwapRouteB("");
      setSwappedTeam([]);
    }
    if (getRosterTemplateRes) {
      rosterExcelExport();
      resetRosterTemplateData();
    }
  }, [
    routeTemplateRes,
    exportRoutesList,
    isSwapSuccessful,
    getRosterTemplateRes,
  ]);

  const excelExport = () => {
    if (_routesTemplateExport.current) {
      _routesTemplateExport.current?.save();
    }
  };
  const rosterExcelExport = () => {
    if (_rosterTemplateExport.current) {
      _rosterTemplateExport.current?.save();
    }
  };
  const routesExcelExport = () => {
    if (_routesExport.current) {
      _routesExport.current?.save();
    }
  };
  const onPageChange = (e: any) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
  };

  const onFilterChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    setFilter(event.target.value);
  };

  const fileHandler = (event: any) => {
    const fileObj = event.target.files[0] as File;
    if (!fileObj) return;
    if (
      ![
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "csv",
      ].includes(fileObj.type)
    )
      return showToast("error", "File formate not supported.");
    ExcelRenderer(fileObj, (err: any, resp: any) => {
      if (err) {
        showToast("error", err);
      } else {
        const rows = resp.rows;

        for (let index = 1; index < rows.length; index++) {
          const routeNo = rows[index][0];
          const teamLeader = rows[index][1];
          const driver = rows[index][2];
          const guard1 = rows[index][3];
          const guard2 = rows[index][4];

          if (guard1) {
            const obj = {
              routeNo,
              teamLeader,
              driver,
              guard1,
              guard2,
            };

            routesTeamsList.current.push(obj);
          }
        }

        if (routesTeamsList.current.length > 0) {
          const locList: any = [];
          routesTeamsList.current.forEach((sl) => {
            locList.push(sl);
          });

          setRoutesTeams(locList);
        } else {
          showToast("error", "No data found in excel file.");
        }
      }
    });
  };

  const processRostersExcelData = (rows: any) => {
    const _routesList: any = [];
    const keys = rows.shift(); //keys,header

    rows.forEach((elm: any) => {
      if (!elm?.length) return;

      const _route = createSingleRoute(elm, keys);
      _routesList.push(_route);
    });

    setRoutesTeams(_routesList);
  };
  const fileHandler2 = (event: any) => {
    if (!event?.target?.files) {
      handleFileUploadError();
      return;
    }

    const fileObj = event.target.files[0];
    ExcelRenderer(fileObj, (err: string, resp: any) => {
      if (err) {
        handleExcelError(err);
        return;
      }
      processRostersExcelData(resp.rows);
    });
  };

  const onBtnUpdateRoutesTeams = () => {
    if (routesTeams.length === 0) {
      showToast("error", "No routes added.");
      return;
    }

    const teams = routesTeams?.map((rt: any) => ({
      routeNo: rt.routeNo ? rt.routeNo.toString() : "",
      teamLeader: rt.teamLeader ? rt.teamLeader.toString() : "",
      driver: rt.driver ? rt.driver.toString() : "",
      guard1: rt.guard1 ? rt.guard1.toString() : "",
      guard2: rt.guard2 ? rt.guard2.toString() : "",
    }));

    updateRoutesTeam(teams);
  };

  const onBtnGenBulkRoaster = () => {
    if (routesTeams.length === 0) {
      showToast("error", "No routes added.");
      return;
    }
    generateBulkRoaster({
      cashCenterId: CashCenterId,
      shift: "morning",
      operationDate: bulkServiceDateTime
        ? formatDate(bulkServiceDateTime, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
        : formatDate(new Date(), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
      routes: [...routesTeams],
    });
  };

  const onBtnGenerateRosterClicked = () => {
    if (!selectedRoutes || selectedRoutes.length === 0) {
      showToast(
        "error",
        "Please select at least one route to generate roster.",
      );
      return;
    }
    const rosterDto = {
      cashCenterId: CashCenterId,
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      shift: "morning",
      routes: selectedRoutes,
    };

    setBtnRosterDisabled(true);

    generateRoster(rosterDto);
  };

  const onOperationsDateChanged = (date: Date) => {
    if (date) setOperationDate(date);
  };

  const onSelectionChange = (event: any) => {
    const newSelectedState = getSelectedState({
      event,
      selectedState,
      dataItemKey: DATA_ITEM_KEY,
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState)?.map((key) => ({
      routeId: key,
      isSelected: newSelectedState[key],
    }));

    const selectedRoutesLocal = selections.filter(
      (req) => req.isSelected === true,
    );

    const routesIds: any = selectedRoutesLocal?.map((rt) => ({
      routeId: rt.routeId,
    }));

    setSelectedRoutes(routesIds);

    if (routesIds.length > 0) {
      setBtnRosterDisabled(false);
      setBtnDeleteRouteDisabled(false);
    } else {
      setBtnRosterDisabled(true);
      setBtnDeleteRouteDisabled(true);
    }
  };

  const onHeaderSelectionChange = (event: any) => {
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState: any = {};

    event.dataItems.forEach((item: any) => {
      newSelectedState[idGetter(item)] = checked;
    });

    setSelectedState(newSelectedState);

    const selections = Object.keys(newSelectedState)?.map((key) => ({
      routeId: key,
      isSelected: newSelectedState[key],
    }));

    const selectedRoutesLocal = selections.filter(
      (req) => req.isSelected === true,
    );

    const routesIds = selectedRoutesLocal?.map((rt) => ({
      routeId: rt.routeId,
    }));

    if (routesIds.length > 0) {
      setBtnRosterDisabled(false);
      setBtnDeleteRouteDisabled(false);
    } else {
      setBtnRosterDisabled(true);
      setBtnDeleteRouteDisabled(true);
    }
  };

  const onBtnDeleteRoutesFromRosterClicked = () => {
    const rosterDto = {
      cashCenterId: CashCenterId,
      operationDate: formatDate(
        operationDate || currentDate,
        "yyyy-MM-dd'T'00:00:00.000'Z'",
      ),
      routes: selectedRoutes,
      shift: "morning",
    };

    setBtnDeleteRouteDisabled(true);
    setBtnDeleteRouteTxt("Deleting Routes from Roster...");
    deleteRoute(rosterDto);
  };
  // -------------------------
  // Updated useEffect: ensure Shift & Remarks columns always present
  // -------------------------

  useEffect(() => {
    if (updateRouteTeamSuccess) {
      setRoutesTeams([]);
      setOpenFileUpload(false);
      routesTeamsList.current = [];
      const error = updateRouteTeamRes?.data;
      if (error) {
        setErrorMessage(error);
        setRefresh(!refresh);
      } else {
        setErrorMessage("");
      }
    }
    if (updateRouteTeamError) {
      setRoutesTeams([]);
      setOpenFileUpload(false);
      routesTeamsList.current = [];
    }
  }, [updateRouteTeamSuccess, updateRouteTeamError]);

  useEffect(() => {
    if (generateRosterSuccess) {
      setOperationDate(currentDate);
      setBtnRosterDisabled(false);
    }
    if (generateRosterError) {
      setBtnRosterDisabled(false);
    }
  }, [generateRosterSuccess, generateRosterError]);

  useEffect(() => {
    if (generateBulkRoasterSuccess) {
      setRoutesTeams([]);
      setOpenBulkUpload(false);
      routesTeamsList.current = [];
    }
    if (generateBulkRoasterError) {
      setRoutesTeams([]);
      setOpenBulkUpload(false);
      routesTeamsList.current = [];
    }
  }, [generateBulkRoasterError, generateBulkRoasterSuccess]);

  useEffect(() => {
    if (deleteRouteSuccess) {
      setBtnDeleteRouteTxt("Delete Routes from Roster");
      setBtnDeleteRouteDisabled(true);
      setSelectedState([]);
      setSelectedRoutes([]);
      setRefresh(true);
    }

    if (deleteRouteError) {
      setBtnDeleteRouteDisabled(true);
      setSelectedState([]);
      setSelectedRoutes([]);
      setBtnDeleteRouteTxt("Delete Routes from Roster");
    }
  }, [deleteRouteSuccess, deleteRouteError]);

  const mergedTeam = (_swapRouteA: string, _swapRouteB: string) => {
    const mergedTeamMembers = [];
    let swapRouteATeam = [];
    let swapRouteBTeam = [];
    if (_swapRouteB) {
      swapRouteBTeam = JSON.parse(_swapRouteB).fieldTeam;
    }
    if (_swapRouteA) {
      swapRouteATeam = JSON.parse(_swapRouteA).fieldTeam;
    }
    if (swapRouteATeam?.length && swapRouteBTeam?.length) {
      while (swapRouteATeam?.length) {
        const memberA = swapRouteATeam.shift();
        const memberB = swapRouteBTeam.find(
          (elm: any) => elm.role === memberA.role,
        );
        if (memberB) {
          const merged = [
            { ...JSON.parse(_swapRouteA), ...memberA },
            { ...JSON.parse(_swapRouteB), ...memberB },
          ];
          mergedTeamMembers.push(merged);
        }
      }
    }

    setSwappedTeam(mergedTeamMembers);
  };
  const editCell = ({ dataItem }: any) => (
    <td className="k-table-td">
      <div
        className="flex justify-center w-full cursor-pointer"
        title="Edit Consumables"
        style={{ textDecoration: "underline" }}
        onClick={() => {
          setOpenEditModal(true);
          setSelectedRoute(dataItem);
        }}
      >
        {dataItem.routeNo}
      </div>
    </td>
  );

  const viewTeamCell = ({ dataItem }: any) => (
    <td className="k-table-td">
      <div className="flex flex-row items-center justify-center w-full">
        <Dialog>
          <DialogTrigger>
            <div className="cursor-pointer">
              <Users />
            </div>
          </DialogTrigger>
          <DialogContent className="max-w-[60vw] w-full">
            <DialogHeader>
              <DialogTitle>Route Field Team</DialogTitle>
            </DialogHeader>
            <div className="flex flex-row flex-wrap gap-[16px] w-full">
              {" "}
              {dataItem.fieldTeam.map((elm: any) => {
                return (
                  <Card
                    style={{ width: `calc(50% - 8px)` }}
                    key={`${elm.role}-${elm.name}`}
                  >
                    <CardContent className="p-4">
                      <div className="flex flex-row justify-between">
                        <p style={{ fontWeight: 500 }}> Name</p>
                        <p className="ml-auto">{elm.name}</p>
                      </div>
                      <div className="border-b my-2 bg-accent" />
                      <div className="flex flex-row justify-between gap-4">
                        <p style={{ fontWeight: 500 }}> Employee ID</p>
                        <p className="ml-auto">{elm.employeeId}</p>
                      </div>
                      <div className="border-b my-2 bg-accent" />
                      <div className="flex flex-row justify-between gap-4">
                        <p style={{ fontWeight: 500 }}> Regulatory ID </p>
                        <p className="ml-auto">{elm.regulatoryId}</p>
                      </div>
                      <div className="border-b my-2 bg-accent" />
                      <div className="flex flex-row justify-between gap-4">
                        <p style={{ fontWeight: 500 }}> Role </p>
                        <p className="ml-auto">{elm.role}</p>
                      </div>
                      <div className="border-b my-2 bg-accent" />
                      <div className="flex flex-row justify-between gap-4">
                        <p style={{ fontWeight: 500 }}> Nationality</p>
                        <p className="ml-auto">{elm.nationality}</p>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
            {/* 
            <div className="flex flex-row gap-8">
              <p style={{ fontWeight: 500, width: "100%", textWrap: "nowrap" }}>
                Route No: {dataItem.routeNo}
              </p>
              <p style={{ fontWeight: 500, width: "100%", textWrap: "nowrap" }}>
                Route Type: {dataItem.routeType}
              </p>
              <p style={{ fontWeight: 500, width: "100%", textWrap: "nowrap" }}>
                Area: {dataItem.area}
              </p>
              <p style={{ fontWeight: 500, width: "100%", textWrap: "nowrap" }}>
                Region: {dataItem.region}
              </p>
            </div> */}
          </DialogContent>
        </Dialog>
      </div>
    </td>
  );

  const routeBulkEditTemplateKeys = React.useMemo(() => {
    const _keys: any = [];
    if (routeTemplateRes) {
      const dataKeys = Object.keys(routeTemplateRes[0]);
      exportRoutesKeys.forEach((key) => {
        if (dataKeys.includes(key)) {
          _keys.push(key);
        }
      });
    }

    return _keys;
  }, [routeTemplateRes]);

  const rosterBulkEditTemplateKeys = React.useMemo(() => {
    const _keys: any = [];
    if (getRosterTemplateRes) {
      const dataKeys = Object.keys(getRosterTemplateRes[0]);
      exportRostersKeys.forEach((key) => {
        if (dataKeys.includes(key)) {
          _keys.push(key);
        }
      });
    }
    return _keys;
  }, [getRosterTemplateRes]);

  useEffect(() => {
    if (exportRoutesRes) {
      const list = exportRoutesRes.map((item: any) => ({
        ...item,
        busTime: item.busTime
          ? moment(item.busTime, "YYYY-MM-DD HH:mm:ss").format("HH:mm")
          : "",
        routeTime: item.routeTime
          ? moment(item.routeTime, "YYYY-MM-DD HH:mm:ss").format("HH:mm")
          : "",

        // Driver Mapping (with Optional Chaining '?.' to prevent errors if null)
        driverId: item.driver?.employeeId || null,
        driverName: item.driver?.name || null,
        driverRegulatoryID: item.driver?.regulatoryId ?? null,
        driverNationality: item.driver?.nationality ?? null,

        // Team Leader Mapping
        teamLeaderId: item.teamLeader?.employeeId || null,
        teamLeaderName: item.teamLeader?.name || null,
        teamLeaderRegulatoryID: item.teamLeader?.regulatoryId ?? null,
        teamLeaderNationality: item.teamLeader?.nationality ?? null,

        // Guard 1 Mapping
        guard1Id: item.guard1?.employeeId || null,
        guard1Name: item.guard1?.name || null,
        guard1RegulatoryID: item.guard1?.regulatoryId ?? null,
        guard1Nationality: item.guard1?.nationality ?? null,

        // Guard 2 Mapping
        guard2Id: item.guard2?.employeeId || null,
        guard2Name: item.guard2?.name || null,
        guard2RegulatoryID: item.guard2?.regulatoryId ?? null,
        guard2Nationality: item.guard2?.nationality ?? null,

        // Guard 3 Mapping
        guard3Id: item.guard3?.employeeId || null,
        guard3Name: item.guard3?.name || null,
        guard3RegulatoryID: item.guard3?.regulatoryId ?? null,
        guard3Nationality: item.guard3?.nationality ?? null,
      }));
      setExportRoutesList(list);
      resetRoutesExport();
    }
  }, [exportRoutesRes]);

  const routeListExportKeys = React.useMemo(() => {
    const _keys: any = [];
    if (exportRoutesList) {
      const dataKeys = Object.keys(exportRoutesList[0]);
      exportRoutesListKeys.forEach((key) => {
        if (dataKeys.includes(key)) {
          _keys.push(key);
        }
      });
    }

    return _keys;
  }, [exportRoutesList]);
  const processRoutesExcelData = (rows: any) => {
    const _routesList: any = [];
    const keys = rows.shift(); //keys,header

    rows.forEach((elm: any) => {
      if (!elm?.length) return;

      const _route = createSingleRoute(elm, keys);
      _routesList.push(_route);
    });

    setUploadRoutes(_routesList);
  };

  const createSingleRoute = (rowData: any, keys: any[]) => {
    const _route: any = {};
    rowData.forEach((item: any, index: number) => {
      _route[keys[index]] = `${item}`;
    });
    keys.forEach((key) => {
      if (_route[key] === undefined) {
        _route[key] = "";
      }
    });

    return _route;
  };

  const handleExcelError = (err: string) => {
    showToast("error", err);
  };

  const handleFileUploadError = () => {
    showToast("error", "Can Not Upload File");
  };

  const routesFileHandler = (event: any) => {
    if (!event?.target?.files) {
      handleFileUploadError();
      return;
    }

    const fileObj = event.target.files[0];
    ExcelRenderer(fileObj, (err: string, resp: any) => {
      if (err) {
        handleExcelError(err);
        return;
      }
      processRoutesExcelData(resp.rows);
    });
  };
  const generateRoutesInBulk = () => {
    editRoutesBulk([...uploadRoutes]);
  };

  const onTeamSwap = () => {
    let routeA: any = {};
    let routeB: any = {};
    if (swapRouteA) {
      routeA = JSON.parse(swapRouteA);
    }
    if (routeB) {
      routeB = JSON.parse(swapRouteB);
    }

    const payload = {
      firstObjId: routeA.routeId,
      secondObjId: routeB.routeId,
      firstTeam: swappedTeam.map((elm: any[]) => ({
        employeeId: elm[0].employeeId,
        regulatoryId: elm[0].regulatoryId,
        name: elm[0].name,
        role: elm[0].role,
        nationality: elm[0].nationality,
      })),
      secondTeam: swappedTeam.map((elm: any) => ({
        employeeId: elm[1].employeeId,
        regulatoryId: elm[1].regulatoryId,
        name: elm[1].name,
        role: elm[1].role,
        nationality: elm[1].nationality,
      })),
    };

    swapRouteTeam(payload);
  };
  const isBulkOperationAllowed = useMemo(() => {
    return (
      Roles.includes("Operations Supervisor") ||
      Roles.includes("PA Assistant") ||
      Roles.includes("PA Supervisor")
    );
  }, [Roles]);
  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>
              Routes Management & Roaster Generation
            </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      <Card className="flex mx-4 flex-col mt-2 gap-4">
        <CardContent className="pt-6">
          <div className="flex flex-row gap-2 mt-3">
            {isOperationAllowed(Permissions.Route, Permissions.Edit) &&
            isBulkOperationAllowed ? (
              <>
                <Button
                  disabled={btnRosterDisabled}
                  variant="secondary"
                  onClick={onBtnGenerateRosterClicked}
                >
                  Generate Roaster
                </Button>
                {isOperationAllowed(Permissions.Route, Permissions.Delete) &&
                isBulkOperationAllowed ? (
                  <Button
                    disabled={btnDeleteRouteDisabled}
                    onClick={onBtnDeleteRoutesFromRosterClicked}
                    variant="secondary"
                  >
                    {btnDeleteRouteTxt}
                  </Button>
                ) : null}
                {isBulkOperationAllowed ? (
                  <Button
                    variant="secondary"
                    onClick={() => {
                      getRosterTemplate({
                        cashCenterId: selectedCashCenter || CashCenterId,
                        region: selectedRegion || null,
                      });
                    }}
                  >
                    <DownloadIcon />
                    <span className="ml-2">Roster Template</span>
                  </Button>
                ) : null}
                {isBulkOperationAllowed ? (
                  <Button
                    variant="secondary"
                    onClick={() => {
                      setOpenBulkUpload(true);
                    }}
                    disabled={generateBulkRoasterPending}
                  >
                    <UploadIcon />
                    <span className="ml-2"> Bulk Roster Upload</span>
                  </Button>
                ) : null}
              </>
            ) : null}
            {isBulkOperationAllowed ? (
              <div className="w-[20%]">
                <DatePicker
                  selectedDate={operationDate}
                  onSelectDate={onOperationsDateChanged}
                  disabled={(date) => date < PREV_DAY_DATE}
                />
              </div>
            ) : null}

            {isBulkOperationAllowed ? (
              <Button
                variant="secondary"
                className="ml-auto"
                onClick={() => {
                  getRouteTemplate({
                    pageNumber: currentPage,
                    pageRowCount: pageSize,
                    searchCriteria: filter.length >= 3 ? filter : "",
                    cashCenterId: selectedCashCenter,
                    region: selectedRegion,
                  });
                }}
              >
                <DownloadIcon />
                <span className="ml-2">Routes Edit Template</span>
              </Button>
            ) : null}
            {isBulkOperationAllowed ? (
              <Button
                variant="secondary"
                onClick={() => {
                  setOpenRoutesFileUpload(true);
                }}
                disabled={editRoutesBulkPending}
              >
                <UploadIcon />
                <span className="ml-2">Routes Bulk Update</span>
              </Button>
            ) : null}
            {isBulkOperationAllowed ? (
              <Dialog>
                <DialogTrigger>
                  <Button variant="secondary">Swap Team</Button>
                </DialogTrigger>

                <DialogContent className="max-w-[900px] w-full max-h-[90vh] h-[90vh] overflow-scroll">
                  <DialogHeader>
                    <DialogTitle>Swap Team</DialogTitle>
                    <div className="flex flex-row items-center justify-between w-full">
                      Swap team members between routes
                      <Button
                        variant="secondary"
                        onClick={onTeamSwap}
                        disabled={
                          !(swapRouteA && swapRouteA !== swapRouteB) ||
                          swappingRouteTeam
                        }
                      >
                        Save
                      </Button>
                    </div>
                    <div className="flex flex-row">
                      <div className="flex flex-col w-[48.5%]">
                        <Combobox
                          setValue={(e: string) => {
                            setSwapRouteA(e);
                            mergedTeam(e, swapRouteB);
                          }}
                          value={swapRouteA}
                          placeholder="Select Route"
                          data={routesToSwap?.map((elm) => ({
                            label: elm.routeNo,
                            value: JSON.stringify(elm),
                          }))}
                        />
                      </div>
                      <div className="flex flex-col w-[5%]" />
                      <div className="flex flex-col w-[48.5%]">
                        <Combobox
                          setValue={(e: string) => {
                            setSwapRouteB(e);
                            mergedTeam(swapRouteA, e);
                          }}
                          value={swapRouteB}
                          placeholder="Select Route"
                          data={routesToSwap?.map((elm) => ({
                            label: elm.routeNo,
                            value: JSON.stringify(elm),
                          }))}
                        />
                      </div>
                    </div>{" "}
                    {swapRouteA && swapRouteA === swapRouteB ? (
                      <p className="pt-2 text-sm text-red-500">
                        Both routes can not be same
                      </p>
                    ) : null}
                  </DialogHeader>

                  {swapRouteA && swapRouteA !== swapRouteB
                    ? swappedTeam?.map((team: any, index: number) => (
                        <div
                          className="flex flex-row pt-2 gap-2"
                          key={`swap_row_${index}`}
                        >
                          <Card className="w-[44%] items-center justify-center">
                            <CardContent className="p-4">
                              <div className="flex flex-row justify-between gap-4">
                                <p style={{ fontWeight: 500 }}> Name</p>
                                <p className="ml-auto">{team[0].name}</p>
                              </div>
                              <div className="border-b my-2 bg-accent" />
                              <div className="flex flex-row justify-between gap-4">
                                <p style={{ fontWeight: 500 }}> Employee ID</p>
                                <p className="ml-auto">{team[0].employeeId}</p>
                              </div>

                              <div className="border-b my-2 bg-accent" />
                              <div className="flex flex-row justify-between gap-4">
                                <p style={{ fontWeight: 500 }}> Role </p>
                                <p className="ml-auto">{team[0].role}</p>
                              </div>
                              <div className="border-b my-2 bg-accent" />
                              <div className="flex flex-row justify-between gap-4">
                                <p style={{ fontWeight: 500 }}> Nationality</p>
                                <p className="ml-auto">{team[0].nationality}</p>
                              </div>
                            </CardContent>
                          </Card>

                          <div className="flex flex-col w-[12%] items-center justify-center">
                            <Button
                              variant="secondary"
                              onClick={() => {
                                const _mergedTeam = [...swappedTeam];
                                _mergedTeam[index] = [team[1], team[0]];
                                setSwappedTeam(_mergedTeam);
                              }}
                            >
                              <MdSwapHoriz
                                fontSize="32px"
                                style={{ cursor: "pointer" }}
                              />
                            </Button>
                          </div>

                          <Card className="w-[44%] items-center justify-center">
                            <CardContent className="p-4">
                              <div className="flex flex-row justify-between gap-4">
                                <p style={{ fontWeight: 500 }}> Name</p>
                                <p className="ml-auto">{team[1].name}</p>
                              </div>
                              <div className="border-b my-2 bg-accent" />
                              <div className="flex flex-row justify-between gap-4">
                                <p style={{ fontWeight: 500 }}> Employee ID</p>
                                <p className="ml-auto">{team[1].employeeId}</p>
                              </div>

                              <div className="border-b my-2 bg-accent" />
                              <div className="flex flex-row justify-between gap-4">
                                <p style={{ fontWeight: 500 }}> Role </p>
                                <p className="ml-auto">{team[1].role}</p>
                              </div>
                              <div className="border-b my-2 bg-accent gap-4" />
                              <div className="flex flex-row justify-between">
                                <p style={{ fontWeight: 500 }}> Nationality</p>
                                <p className="ml-auto">{team[1].nationality}</p>
                              </div>
                            </CardContent>
                          </Card>
                        </div>
                      ))
                    : null}

                  {/* --- ROW 1: THE HEADERS --- */}
                  {/* Combobox A */}

                  {/* Combobox B */}
                </DialogContent>
              </Dialog>
            ) : null}

            <Button
              variant="secondary"
              disabled={gettingRoutesExport}
              onClick={() => {
                exportRoutes({
                  pageNumber: currentPage,
                  pageRowCount: pageSize,
                  searchCriteria: filter.length >= 3 ? filter : "",
                  cashCenterId: selectedCashCenter,
                  region: selectedRegion,
                });
              }}
            >
              <FaFileExcel fontSize="16px" size={16} />
              <span className="ml-2">Export</span>
            </Button>
          </div>
          <div className="border-b my-3 bg-accent" />
          <div className="flex flex-row gap-2 mt-3">
            <div className="w-[20%]">
              <Combobox
                setValue={setSelectedCashCenter}
                value={selectedCashCenter}
                disabled={!Roles.includes("PA Supervisor")}
                placeholder="Select Cash Center"
                data={
                  cashCenters?.map((elm) => ({
                    label: elm.name,
                    value: elm.cashCenterId,
                  })) || []
                }
              />
            </div>
            <div className="w-[20%]">
              <Combobox
                setValue={setSelectedRegion}
                value={selectedRegion}
                disabled={
                  !(
                    Roles.includes("PA Supervisor") ||
                    Roles.includes("PA Assistant")
                  )
                }
                placeholder="Select Region"
                data={
                  regions?.map((elm: any) => ({
                    label: elm.name,
                    value: elm.name,
                  })) || []
                }
              />
            </div>
            <Input
              className="w-full ml-auto"
              value={filter}
              onChange={onFilterChange}
              placeholder="Search: RouteNo, Route Type, Van Registration No, Cash Box Serial, HHT Serial, Printer Serial"
            />
          </div>
          <div className="flex mt-3">
            <div className="flex-1" />
            <div className="flex-1">
              {errorMessage ? (
                <div>
                  <label className="h5 text-error w-100">
                    Routes' team not updated, please check validations
                  </label>
                  <br />
                  <br />
                  <label className="h5 text-error w-100">{errorMessage}</label>
                </div>
              ) : null}
            </div>
          </div>
          <div className="border-b mt-3 mb-3 bg-accent" />
          {loadingRequests ? (
            <div className="k-loading-mask">
              <span className="k-loading-text">Loading</span>
              <div className="k-loading-image" />
              <div className="k-loading-color" />
            </div>
          ) : null}
          <Grid
            sortable
            filterable
            dataItemKey={DATA_ITEM_KEY}
            selectedField={SELECTED_FIELD}
            selectable={{
              enabled: true,
              drag: true,
              cell: false,
              mode: "multiple",
            }}
            data={process(
              routes?.data?.map((req: any) => ({
                ...req,
                [SELECTED_FIELD]: selectedState[idGetter(req)],
              })) || [],
              { ...dataState, skip: 0 },
            )}
            {...dataState}
            onDataStateChange={(e) => {
              setDataState(e.dataState);
            }}
            onSelectionChange={onSelectionChange}
            onHeaderSelectionChange={onHeaderSelectionChange}
            pageable
            total={routes?.totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
          >
            <Column
              field={SELECTED_FIELD}
              filterable={false}
              width="50px"
              headerSelectionValue={
                routes?.data?.findIndex(
                  (item: any) => !selectedState[idGetter(item)],
                ) === -1
              }
              className="text-center"
            />
            <Column
              filterable={false}
              title="Route No."
              headerClassName="text-center"
              className="text-center"
              width={160}
              cell={editCell}
            />
            <Column field="routeType" title="Route Type" width={160} />

            <Column field="description" title="Description" width={200} />
            <Column field="routeArea" title="Area" width={160} />
            <Column field="region" title="Region" width={160} />
            <Column
              field="busTime"
              title="Bus Time"
              width={100}
              headerClassName="text-center"
              className="text-center"
              cell={({ dataItem }) => {
                const time = dataItem?.busTime
                  ?.split("T")
                  .join(" ")
                  .replace("Z", "");
                if (time) {
                  return (
                    <td className="k-table-td text-center">
                      {moment(time, "YYYY-MM-DD HH:mm:ss").format("HH:mm")}
                    </td>
                  );
                }
                return <td />;
              }}
            />
            <Column
              field="routeTime"
              title="Route Time"
              width={120}
              headerClassName="text-center"
              className="text-center"
              cell={({ dataItem }) => {
                const time = dataItem?.routeTime
                  ?.split("T")
                  .join(" ")
                  .replace("Z", "");
                if (time) {
                  return (
                    <td className="k-table-td text-center">
                      {moment(time, "YYYY-MM-DD HH:mm:ss").format("HH:mm")}
                    </td>
                  );
                }
                return <td />;
              }}
            />
            <Column
              field="cashBoxSerial"
              title="Cash Box Serial"
              width={160}
              headerClassName="text-center"
              className="text-center"
            />
            <Column
              field="hhtSerial"
              title="HHT Serial"
              width={100}
              headerClassName="text-center"
              className="text-center"
            />
            <Column
              field="printerSerial"
              title="Printer Serial"
              width={120}
              headerClassName="text-center"
              className="text-center"
            />
            <Column
              field="teamNationalityCount"
              title="Team Nationality Count"
              width={200}
              headerClassName="text-center"
              className="text-center"
            />
            <Column
              field="requiredTeamMembers"
              title="Team Members"
              width={140}
              headerClassName="text-center"
              className="text-center"
            />
            <Column
              field="vanRegistrationNo"
              title="Van Registration No"
              width={160}
              headerClassName="text-center"
              className="text-center"
            />
            <Column field="requestedBy" title="Requested By" width={120} />

            <Column width={100} field="status" title="Status" />

            <Column
              filterable={false}
              title="Team"
              headerClassName="text-center"
              className="text-center"
              width={80}
              cell={viewTeamCell}
            />
          </Grid>
        </CardContent>
      </Card>

      <Dialog
        open={openFileUpload}
        onOpenChange={(open) => {
          setOpenFileUpload(open);
          setRoutesTeams([]);
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Upload Field Teams</DialogTitle>
          </DialogHeader>
          <DialogDescription>
            {routesTeams?.length ? (
              <div className="flex flex-col items-center justify-center py-5">
                <p className="mb-5 text-gray-500 dark:text-gray-400">
                  File uploaded successfully!. Now update field team
                </p>
                <Button
                  disabled={updateRouteTeamPending}
                  isLoading={updateRouteTeamPending}
                  variant="secondary"
                  onClick={onBtnUpdateRoutesTeams}
                >
                  Update Filed Team
                </Button>
              </div>
            ) : (
              <div className="flex items-center justify-center w-full">
                <label
                  htmlFor="dropzone-file"
                  className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                >
                  <div className="flex flex-col items-center justify-center pt-5 pb-6">
                    <svg
                      className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 20 16"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                      />
                    </svg>
                    <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                      <span className="font-semibold">Click to upload</span> or
                      drag and drop
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      XLS, XLSX, CSV (MAX. 5GB)
                    </p>
                  </div>
                  <input
                    id="dropzone-file"
                    accept=".xlsx, .xls, .csv"
                    type="file"
                    className="hidden"
                    onChange={fileHandler}
                  />
                </label>
              </div>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openBulkUpload}
        onOpenChange={(open) => {
          setOpenBulkUpload(open);
          setRoutesTeams([]);
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Upload Bulk Rosters</DialogTitle>
          </DialogHeader>
          <DialogDescription>
            {routesTeams?.length ? (
              <div className="flex flex-col items-center justify-center py-5">
                <p className="mb-5 text-gray-500 dark:text-gray-400">
                  File uploaded successfully!. Now update rosters
                </p>
                <Button
                  disabled={generateBulkRoasterPending}
                  isLoading={generateBulkRoasterPending}
                  variant="secondary"
                  onClick={onBtnGenBulkRoaster}
                >
                  Update Rosters
                </Button>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center w-full gap-4">
                <div className="w-[100%] flex flex-col">
                  <label className="mb-2 font-semibold">Operation Date</label>
                  <DatePicker
                    disabled={(date) => date < PREV_DAY_DATE}
                    placeholder="Select Service Date"
                    selectedDate={bulkServiceDateTime}
                    onSelectDate={onBulkServiceDateChanged}
                  />
                </div>
                <label
                  htmlFor="dropzone-file"
                  className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                >
                  <div className="flex flex-col items-center justify-center pt-5 pb-6">
                    <svg
                      className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 20 16"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                      />
                    </svg>
                    <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                      <span className="font-semibold">Click to upload</span> or
                      drag and drop
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      XLS, XLSX, CSV (MAX. 5GB)
                    </p>
                  </div>
                  <input
                    id="dropzone-file"
                    accept=".xlsx, .xls, .csv"
                    type="file"
                    className="hidden"
                    onChange={fileHandler2}
                  />
                </label>
              </div>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openRoutesFileUpload}
        onOpenChange={(open) => {
          setOpenRoutesFileUpload(open);
          setUploadRoutes([]);
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Upload Bulk Routes</DialogTitle>
          </DialogHeader>
          <DialogDescription>
            {uploadRoutes?.length ? (
              <div className="flex flex-col items-center justify-center py-5">
                <p className="mb-5 text-gray-500 dark:text-gray-400">
                  File uploaded successfully!. Now update routes
                </p>
                <Button variant="secondary" onClick={generateRoutesInBulk}>
                  Update Routes
                </Button>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center w-full gap-4">
                <label
                  htmlFor="dropzone-file"
                  className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
                >
                  <div className="flex flex-col items-center justify-center pt-5 pb-6">
                    <svg
                      className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 20 16"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                      />
                    </svg>
                    <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                      <span className="font-semibold">Click to upload</span> or
                      drag and drop
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      XLS, XLSX, CSV (MAX. 5GB)
                    </p>
                  </div>
                  <input
                    id="dropzone-file"
                    accept=".xlsx, .xls, .csv"
                    type="file"
                    className="hidden"
                    onChange={routesFileHandler}
                  />
                </label>
              </div>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>

      <Dialog open={openEditModal} onOpenChange={setOpenEditModal}>
        <DialogContent
          className="max-w-[70vw] w-full"
          onOpenAutoFocus={(e) => {
            e.preventDefault();
          }}
        >
          <DialogHeader>
            <DialogTitle>Edit Route</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-4">
            <EditRoute
              route={selectedRoute}
              onRouteUpdated={async () => {
                setOpenEditModal(false);
                await refetchRoutes();
                await refetchSwapRoutes();
              }}
            />
          </DialogDescription>
        </DialogContent>
      </Dialog>
      <ExcelExport
        data={routeTemplateRes || []}
        fileName="Routes_Bulk_Edit_Template.xlsx"
        ref={_routesTemplateExport as any}
      >
        {routeBulkEditTemplateKeys.map((elm: any) => (
          <Column key={elm} field={elm} title={elm} />
        ))}
      </ExcelExport>

      <ExcelExport
        data={getRosterTemplateRes || []}
        fileName="Rosters_Bulk_Edit_Template.xlsx"
        ref={_rosterTemplateExport as any}
      >
        {rosterBulkEditTemplateKeys.map((elm: any) => (
          <Column key={elm} field={elm} title={elm} />
        ))}
      </ExcelExport>

      <ExcelExport
        data={exportRoutesList || []}
        fileName="Routes.xlsx"
        ref={_routesExport as any}
      >
        {routeListExportKeys.map((elm: any) => (
          <Column key={elm} field={elm} title={elm} />
        ))}
      </ExcelExport>
    </Layout>
  );
}
